// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"HeroCta_buttonContainer__ibS0h","text":"HeroCta_text__ECK_Y"};